import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { Observable, Observer } from 'rxjs';

@Injectable()
export class TrackingScriptService {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private scriptElement: any;
  private readonly scriptType = 'text/javascript';

  private loaded: boolean = false;
  private scriptScr: string = '';
  private renderer: Renderer2;

  public constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  public load(scriptSrc: string, scriptName: string, onUnload?: () => void): Observable<boolean> {
    return new Observable((observer: Observer<boolean>) => {
      if (this.loaded && this.scriptScr !== scriptSrc) {
        this.removeScript(scriptName);
        if (onUnload) {
          onUnload();
        }
        this.createScript(observer, scriptSrc);
        return;
      }
      if (this.loaded) {
        observer.next(false);
        observer.complete();
        return;
      }
      this.createScript(observer, scriptSrc);
    });
  }

  public unload(scriptName: string): void {
    if (!this.scriptElement) {
      return;
    }

    this.removeScript(scriptName);
    this.scriptElement = undefined;
    this.loaded = false;
  }

  private removeScript(scriptName: string): void {
    Array.from(document.querySelectorAll('script'))
      .filter((x) => x.src.includes(scriptName))
      .forEach((script) => {
        this.renderer.removeChild(document.head, script);
      });
    this.renderer.removeChild(document.head, this.scriptElement);
  }

  private createScript(observer: Observer<boolean>, scriptSrc: string): void {
    const scriptElement = this.renderer.createElement('script');
    scriptElement.type = this.scriptType;
    scriptElement.src = scriptSrc;
    scriptElement.onload = (): void => {
      this.loaded = true;
      observer.next(false);
      observer.complete();
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    scriptElement.onerror = (error: any): void => {
      observer.error(`Couldn't load tracking script. ${error}`);
    };
    this.scriptScr = scriptSrc;
    this.scriptElement = scriptElement;
    this.renderer.appendChild(document.head, this.scriptElement);
  }
}
